import { injectGlobal } from "styled-components"

/* eslint no-unused-expressions: 0 */
injectGlobal`
    #nprogress .bar {
        background: red !important;
    }

    #nprogress .peg {
        box-shadow: 0 0 10px red, 0 0 5px red !important;
    }

    #nprogress .spinner-icon {
        border-top-color: red !important;
        border-left-color: red !important;
    }
`



// WEBPACK FOOTER //
// ./src/globalStyle.js